import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@heroui/react';
import { useCatalogImport } from '@/pages/catalogImport/store';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * "Importing into <branch>": the frame's context line on the steps after
 * Branch. Reads the import store, so it renders inside the wizard's
 * `CatalogImportProvider`; nothing while no branch is chosen.
 */
export const ChosenBranch: React.FC = () => {
    const { t } = useTranslation('pages');
    const { branch } = useCatalogImport().state;

    if (!branch) {
        return null;
    }

    return (
        <Typography
            color="muted"
            type="body-sm"
            {...getNodeTestIdProp('onboarding-chosen-branch')}
        >
            {t('onboarding.frame.importingInto', { branch: branch.name })}
        </Typography>
    );
};
